import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavigationContextService } from '../../../core/services/navigation-context.service';
import { AccessService } from '../../../core/services/access.service';

@Component({
  selector: 'pp-secondary-nav',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './secondary-nav.component.html',
})
export class SecondaryNavComponent {
  private readonly navContext = inject(NavigationContextService);
  private readonly access = inject(AccessService);

  /** Same pages as the sidebar: filtered by the user's abilities and the Settings › Features toggles. */
  readonly tabs = computed(() => {
    const route = this.navContext.activeModule()?.route;
    return this.access.navItems().find((item) => item.route === route)?.children ?? [];
  });
}
